import axios from "axios";
import { getApiBaseUrl } from './apiUrl';

class KedoApi {
  endpoint
  constructor(endpoint) {
    this.api = axios.create({
      baseURL: getApiBaseUrl()
    });
    this.endpoint = endpoint
  }

  async Create(datas, apiUsername, apiKey) {
    try {
      const config =
        apiUsername && apiKey
          ? {
            headers: {
              "x-use-alternative": "true",
              "X-Api-Username": apiUsername,
              "X-Api-Key": apiKey,
            },
          }
          : {};
      let { data } = await this.api.post(this.endpoint, datas, config);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async Put(id, queryParams, datas) {
    try {
      const url = `${this.endpoint}/${id}?${new URLSearchParams(queryParams).toString()}`;
      const { data } = await this.api.put(url, datas);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async Get(id) {
    try {
      const url = `${this.endpoint}/${id}`;
      const { data } = await this.api.get(url);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async GetList(params, credentials) {
    try {

      const url = `${this.endpoint}`;
      let config = {}

      if (credentials && credentials?.apiUsername && credentials?.apiKey) {

        config = {
          headers: {
            "x-use-alternative": "true",
            "X-Api-Username": credentials?.apiUsername,
            "X-Api-Key": credentials?.apiKey,
          }
        }
      }
      let { data } = await this.api.get(url, { params, ...config });

      return data;
    } catch (error) {
      throw error;
    }
  }

  async GetDefdossier(params) {
    try {
      let query = "";
      const url = `${this.endpoint}`;
      if (params) {
        query = `?${this.convertToQuery(params)}`;
      }
      const { data } = await this.api.get(url, {
        params
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  convertToQuery(params) {
    return Object.keys(params)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join("&");
  }

  Update() { }
  Delete() { }
  convertParamsToQuery(params) {
    const query =
      "?" +
      Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&");

    return query;
  }
}

export default KedoApi;
